var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      staticClass: "modal-edit-deliverable",
      attrs: {
        visible: _vm.visible,
        size: "xl",
        "no-close-on-backdrop": "",
        "no-close-on-esc": "",
        "hide-footer": "",
        "hide-header": "",
        id: "dupPostSelectionModal"
      },
      on: {
        hide: function($event) {
          return _vm.$emit("close")
        },
        shown: _vm.onModalShown
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "edit-osmp-deliverable-modal no-focus-visible-outline",
          attrs: { tabindex: "-1" }
        },
        [
          _c(
            "div",
            { staticClass: "departments__wrapper" },
            _vm._l(_vm.deliverable.departments, function(dept, idx) {
              return _c(
                "div",
                {
                  key: "post-modal-dept-" + dept.department_id,
                  staticClass: "department-title"
                },
                [
                  idx > 0 ? _c("span", [_vm._v(" &")]) : _vm._e(),
                  _vm._v(" " + _vm._s(dept.name) + "\n      ")
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "h1",
            {
              staticClass: "deliverable-title edit-d-title",
              staticStyle: { cursor: "default" }
            },
            [_vm._v("\n      " + _vm._s(_vm.deliverable.title) + "\n    ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "responsive-edit-modal-controls",
              class: _vm.showModalOptions ? "open" : ""
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn modal-more-controls",
                  on: {
                    click: function($event) {
                      _vm.showModalOptions = !_vm.showModalOptions
                    }
                  }
                },
                [
                  _c("i", {
                    staticClass: "fas",
                    class: !_vm.showModalOptions
                      ? "fa-arrow-left"
                      : "fa-arrow-right"
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn close-deliverable-btn",
                  on: {
                    click: function($event) {
                      return _vm.$emit("close")
                    }
                  }
                },
                [_c("i", { staticClass: "fas fa-times" })]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-inline dup-post-header-controls mb-2 mt-2" },
            [
              _c("div", { staticClass: "input-group top-search" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.searchQuery,
                      expression: "searchQuery"
                    }
                  ],
                  ref: "searchQuery",
                  staticClass: "form-control media-calls-search",
                  attrs: { type: "text", placeholder: "Search posts..." },
                  domProps: { value: _vm.searchQuery },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.searchQuery = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "input-group-append cursor-pointer" },
                  [
                    _c("span", { staticClass: "input-group-text" }, [
                      _c("i", { staticClass: "fas fa-search" })
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "ml-2 mr-2 header-filter-btns",
                  attrs: { id: "dup-post-filter-btn", variant: "theme" }
                },
                [
                  _c("span", [_vm._v("Filter")]),
                  _vm._v(" "),
                  _c("img", {
                    attrs: { src: require("@/csmworkflow/img/filter.svg") }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "b-popover",
                {
                  ref: "dupPostFilterPopover",
                  attrs: {
                    triggers: "click blur",
                    boundary: "window",
                    placement: "bottom",
                    target: "dup-post-filter-btn",
                    "custom-class": "deliverable-filter"
                  }
                },
                [
                  _c("div", { staticClass: "d-flex flex-row" }, [
                    _c("div", { staticClass: "grouped-filter-item" }, [
                      _c(
                        "div",
                        { staticClass: "filter-item item__coordinator" },
                        [
                          _c("label", [_vm._v("Assigned To")]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "coordinator-wrap" },
                            [
                              _c("multiselect", {
                                attrs: {
                                  options: _vm.allActiveUsers,
                                  "show-labels": false,
                                  multiple: true,
                                  "open-direction": "bottom",
                                  label: "name",
                                  "track-by": "id",
                                  "hide-selected": true,
                                  "close-on-select": false,
                                  "clear-on-select": false
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "selection",
                                    fn: function(ref) {
                                      var values = ref.values
                                      var isOpen = ref.isOpen
                                      return [
                                        values.length && !isOpen
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "multiselect__single"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(values.length) +
                                                    " selected"
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ]),
                                model: {
                                  value: _vm.filterQuery.coordinator,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.filterQuery,
                                      "coordinator",
                                      $$v
                                    )
                                  },
                                  expression: "filterQuery.coordinator"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "filter-item item__social_network" },
                        [
                          _c("label", [_vm._v("Social Network")]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "social-network-wrap" },
                            [
                              _c("multiselect", {
                                attrs: {
                                  options: _vm.socialNetworkOptions,
                                  "show-labels": false,
                                  multiple: true,
                                  "open-direction": "bottom",
                                  label: "network_name",
                                  "track-by": "id",
                                  "hide-selected": true,
                                  "close-on-select": false,
                                  "clear-on-select": false
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "option",
                                    fn: function(props) {
                                      return [
                                        _c("div", [
                                          _c("i", {
                                            class:
                                              "fab fa-" +
                                              _vm.getSocialNetworkClassLocal(
                                                props.option.api_type
                                              )
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(props.option.network_name)
                                          )
                                        ])
                                      ]
                                    }
                                  },
                                  {
                                    key: "selection",
                                    fn: function(ref) {
                                      var values = ref.values
                                      var isOpen = ref.isOpen
                                      return [
                                        values.length && !isOpen
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "multiselect__single"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(values.length) +
                                                    " selected"
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ]),
                                model: {
                                  value: _vm.filterQuery.socialNetwork,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.filterQuery,
                                      "socialNetwork",
                                      $$v
                                    )
                                  },
                                  expression: "filterQuery.socialNetwork"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "grouped-filter-item" }, [
                      _c("div", { staticClass: "filter-item item__tag" }, [
                        _c("label", [_vm._v("Tag")]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "tag-wrap" },
                          [
                            _c(
                              "multiselect",
                              {
                                attrs: {
                                  options: _vm.tagOptions,
                                  "show-labels": false,
                                  multiple: true,
                                  "open-direction": "bottom",
                                  label: "name",
                                  "track-by": "id",
                                  "hide-selected": true,
                                  "close-on-select": false,
                                  "clear-on-select": false,
                                  loading: _vm.isTagsLoading,
                                  "preserve-search": true
                                },
                                on: { "search-change": _vm.onTagSearch },
                                scopedSlots: _vm._u([
                                  {
                                    key: "selection",
                                    fn: function(ref) {
                                      var values = ref.values
                                      var isOpen = ref.isOpen
                                      return [
                                        values.length && !isOpen
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "multiselect__single"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(values.length) +
                                                    " selected"
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ]),
                                model: {
                                  value: _vm.filterQuery.tag,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filterQuery, "tag", $$v)
                                  },
                                  expression: "filterQuery.tag"
                                }
                              },
                              [
                                _vm._v(" "),
                                _c("template", { slot: "noOptions" }, [
                                  _vm._v("Start typing to find tags.")
                                ]),
                                _vm._v(" "),
                                _c("template", { slot: "noResult" }, [
                                  _vm._v("No results.")
                                ])
                              ],
                              2
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "filter-item item__department" },
                        [
                          _c("label", [_vm._v("Department")]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "tag-wrap" },
                            [
                              _c("multiselect", {
                                attrs: {
                                  options: _vm.departmentOptions,
                                  "show-labels": false,
                                  multiple: true,
                                  "open-direction": "bottom",
                                  label: "name",
                                  "track-by": "id",
                                  "hide-selected": true,
                                  "close-on-select": false,
                                  "clear-on-select": false
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "selection",
                                    fn: function(ref) {
                                      var values = ref.values
                                      var isOpen = ref.isOpen
                                      return [
                                        values.length && !isOpen
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "multiselect__single"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(values.length) +
                                                    " selected"
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ]),
                                model: {
                                  value: _vm.filterQuery.department,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filterQuery, "department", $$v)
                                  },
                                  expression: "filterQuery.department"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-checkbox",
                            {
                              staticClass: "mt-2 csm-checkbox",
                              model: {
                                value: _vm.filterQuery.noDepartment,
                                callback: function($$v) {
                                  _vm.$set(_vm.filterQuery, "noDepartment", $$v)
                                },
                                expression: "filterQuery.noDepartment"
                              }
                            },
                            [_vm._v("No Department")]
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "filter-item item__date" }, [
                      _c("div", { staticClass: "due__created__dates" }, [
                        _c(
                          "div",
                          [
                            _c("label", { staticClass: "mt-2" }, [
                              _vm._v("Created")
                            ]),
                            _c("br"),
                            _vm._v(" "),
                            _c("date-range-picker", {
                              ref: "pickerDateCreated",
                              attrs: { autoApply: true },
                              on: {
                                update: function($event) {
                                  _vm.filterQuery.filterByCreatedDate = true
                                }
                              },
                              model: {
                                value: _vm.filterQuery.createdDateRange,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.filterQuery,
                                    "createdDateRange",
                                    $$v
                                  )
                                },
                                expression: "filterQuery.createdDateRange"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c("label", { staticClass: "mt-lg-2" }, [
                              _vm._v("Post Date")
                            ]),
                            _c("br"),
                            _vm._v(" "),
                            _c("date-range-picker", {
                              ref: "pickerPostDate",
                              attrs: { autoApply: true },
                              on: {
                                update: function($event) {
                                  _vm.filterQuery.filterByPostDate = true
                                }
                              },
                              model: {
                                value: _vm.filterQuery.postDateRange,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.filterQuery,
                                    "postDateRange",
                                    $$v
                                  )
                                },
                                expression: "filterQuery.postDateRange"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "div",
                        { staticClass: "item__reset" },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                variant: "theme",
                                title: "Reset All Filters",
                                size: "sm"
                              },
                              on: { click: _vm.resetFilter }
                            },
                            [_c("i", { staticClass: "fas fa-undo" })]
                          )
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.hasActiveFilters
                    ? _c(
                        "div",
                        { staticClass: "d-none d-md-block mt-3" },
                        [
                          _c("label", [_vm._v("Click to remove filters:")]),
                          _c("br"),
                          _vm._v(" "),
                          _vm._l(_vm.filterQuery.coordinator, function(c) {
                            return _c(
                              "span",
                              {
                                key: "fc-" + c.id,
                                staticClass:
                                  "badge badge-primary mr-2 mb-2 cursor-pointer",
                                on: {
                                  click: function($event) {
                                    return _vm.removeFilter("coordinator", c)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(c.name))]
                            )
                          }),
                          _vm._v(" "),
                          _vm._l(_vm.filterQuery.socialNetwork, function(n) {
                            return _c(
                              "span",
                              {
                                key: "fn-" + n.id,
                                staticClass:
                                  "badge badge-primary mr-2 mb-2 cursor-pointer",
                                on: {
                                  click: function($event) {
                                    return _vm.removeFilter("socialNetwork", n)
                                  }
                                }
                              },
                              [
                                _c("i", {
                                  class:
                                    "fab fa-" +
                                    _vm.getSocialNetworkClassLocal(n.api_type)
                                }),
                                _vm._v(" " + _vm._s(n.network_name))
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _vm._l(_vm.filterQuery.tag, function(t) {
                            return _c(
                              "span",
                              {
                                key: "ft-" + t.id,
                                staticClass:
                                  "badge badge-primary mr-2 mb-2 cursor-pointer",
                                on: {
                                  click: function($event) {
                                    return _vm.removeFilter("tag", t)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(t.name))]
                            )
                          }),
                          _vm._v(" "),
                          _vm._l(_vm.filterQuery.department, function(d) {
                            return _c(
                              "span",
                              {
                                key: "fd-" + d.id,
                                staticClass:
                                  "badge badge-primary mr-2 mb-2 cursor-pointer",
                                on: {
                                  click: function($event) {
                                    return _vm.removeFilter("department", d)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(d.name))]
                            )
                          }),
                          _vm._v(" "),
                          _vm.filterQuery.noDepartment
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "badge badge-primary mr-2 mb-2 cursor-pointer",
                                  on: {
                                    click: function($event) {
                                      _vm.filterQuery.noDepartment = false
                                    }
                                  }
                                },
                                [_vm._v("No Department")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.filterQuery.filterByCreatedDate
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "badge badge-primary mr-2 mb-2 cursor-pointer",
                                  on: {
                                    click: function($event) {
                                      _vm.filterQuery.filterByCreatedDate = false
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "Created: " +
                                      _vm._s(
                                        _vm._f("moment")(
                                          _vm.filterQuery.createdDateRange
                                            .startDate,
                                          "MMM DD"
                                        )
                                      ) +
                                      " - " +
                                      _vm._s(
                                        _vm._f("moment")(
                                          _vm.filterQuery.createdDateRange
                                            .endDate,
                                          "MMM DD"
                                        )
                                      )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.filterQuery.filterByPostDate
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "badge badge-primary mr-2 mb-2 cursor-pointer",
                                  on: {
                                    click: function($event) {
                                      _vm.filterQuery.filterByPostDate = false
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "Post Date: " +
                                      _vm._s(
                                        _vm._f("moment")(
                                          _vm.filterQuery.postDateRange
                                            .startDate,
                                          "MMM DD"
                                        )
                                      ) +
                                      " - " +
                                      _vm._s(
                                        _vm._f("moment")(
                                          _vm.filterQuery.postDateRange.endDate,
                                          "MMM DD"
                                        )
                                      )
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        2
                      )
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _vm.languages.length > 0
                ? _c(
                    "div",
                    { staticClass: "post-content-switcher-wrapper mr-2" },
                    [
                      _c(
                        "div",
                        { staticClass: "switch-toggle" },
                        [
                          _vm._l(_vm.languages, function(lang, idx) {
                            return [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.showPostContentLang,
                                    expression: "showPostContentLang"
                                  }
                                ],
                                key: "dup-lang-input-" + idx,
                                staticClass: "no-focus-visible-outline",
                                attrs: {
                                  id: "dup_post_lang_" + idx,
                                  name: "dup_post_lang",
                                  type: "radio"
                                },
                                domProps: {
                                  value: lang.id,
                                  checked: _vm._q(
                                    _vm.showPostContentLang,
                                    lang.id
                                  )
                                },
                                on: {
                                  change: function($event) {
                                    _vm.showPostContentLang = lang.id
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover",
                                      modifiers: { hover: true }
                                    }
                                  ],
                                  key: "dup-lang-label-" + idx,
                                  staticClass: "no-focus-visible-outline",
                                  attrs: {
                                    for: "dup_post_lang_" + idx,
                                    title: lang.lang_name
                                  }
                                },
                                [_vm._v(_vm._s(lang.lang_code))]
                              )
                            ]
                          }),
                          _vm._v(" "),
                          _c("a", {
                            staticClass: "btn no-focus-visible-outline"
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "switch-toggle" },
                        [
                          _vm._l(_vm.socialNetworkOptions, function(
                            network,
                            idx2
                          ) {
                            return [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.showPostContentNetwork,
                                    expression: "showPostContentNetwork"
                                  }
                                ],
                                key: "dup-net-input-" + idx2,
                                staticClass: "no-focus-visible-outline",
                                attrs: {
                                  id: "dup_post_net_" + idx2,
                                  name: "dup_post_net",
                                  type: "radio"
                                },
                                domProps: {
                                  value: network.id,
                                  checked: _vm._q(
                                    _vm.showPostContentNetwork,
                                    network.id
                                  )
                                },
                                on: {
                                  change: function($event) {
                                    _vm.showPostContentNetwork = network.id
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover",
                                      modifiers: { hover: true }
                                    }
                                  ],
                                  key: "dup-net-label-" + idx2,
                                  staticClass: "no-focus-visible-outline",
                                  attrs: {
                                    for: "dup_post_net_" + idx2,
                                    title: network.network_name
                                  }
                                },
                                [
                                  _c("i", {
                                    class:
                                      "fab fa-" +
                                      _vm.getSocialNetworkClassLocal(
                                        network.api_type
                                      ) +
                                      " platform-indicator"
                                  })
                                ]
                              )
                            ]
                          }),
                          _vm._v(" "),
                          _c("a", {
                            staticClass: "btn no-focus-visible-outline"
                          })
                        ],
                        2
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex align-items-center w-100 mt-2" },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-primary mr-2",
                      on: { click: _vm.selectAllFiltered }
                    },
                    [_vm._v("All")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-primary mr-3",
                      on: { click: _vm.clearAllPosts }
                    },
                    [_vm._v("None")]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "dup-selection-count",
                      staticStyle: { "font-weight": "700" }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.selectedCount) +
                          " / " +
                          _vm._s(_vm.totalCount)
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "deliverable-listing social-media grouped-by-date pt-0"
            },
            [
              _c("div", { staticClass: "deliverable-block" }, [
                _c("div", { staticClass: "delv-block-resp" }, [
                  _c("div", { staticClass: "d-flex flex-row dbox-wrapper" }, [
                    _c(
                      "div",
                      { staticClass: "dbox-left-side dleft-inner-wrap" },
                      [
                        _c(
                          "div",
                          { staticClass: "dtable" },
                          [
                            _c(
                              "div",
                              { staticClass: "dtr top-row social list-labels" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "dtd info-heading titles" },
                                  [_c("span", [_vm._v("Post Name")])]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "dtd info-heading users" },
                                  [_c("span", [_vm._v("People")])]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "dtd info-heading publish-date"
                                  },
                                  [_c("span", [_vm._v("Number of Posts")])]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "dtd info-heading caption" },
                                  [_c("span", [_vm._v("Post Copy")])]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "dtd info-heading thumbnail" },
                                  [_c("span", [_vm._v("Image")])]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "dtd info-heading social-network"
                                  },
                                  [_c("span", [_vm._v("Platforms")])]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "dtd info-heading languages" },
                                  [_c("span", [_vm._v("EN/FR")])]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.filteredPosts.length === 0
                              ? _c("div", { staticClass: "text-center p-4" }, [
                                  _c("p", { staticClass: "text-muted" }, [
                                    _vm._v("No posts match your filters.")
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(_vm.groupedPosts, function(group, gIdx) {
                              return [
                                !group.isSeries
                                  ? _c(
                                      "div",
                                      {
                                        key: "dup-post-row-" + group.master.id,
                                        staticClass: "dtr listing-row",
                                        class: {
                                          "dup-item-selected": _vm.isPostSelected(
                                            group.master.id
                                          )
                                        },
                                        attrs: {
                                          "data-deliverable-id": group.master.id
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "dtd titles breakpoint__fix"
                                          },
                                          [
                                            _c("div", {
                                              staticClass:
                                                "list-deliverable-status-bar",
                                              style: {
                                                borderLeftColor: _vm.getStatusColor(
                                                  group.master
                                                )
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "deliverable-title edit-d-title-stacked delete-bar-left cursor-pointer",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.toggleSoloPost(
                                                      group.master
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("b-form-checkbox", {
                                                  staticClass:
                                                    "mr-2 dup-item-checkbox d-inline-block",
                                                  attrs: {
                                                    checked: _vm.isPostSelected(
                                                      group.master.id
                                                    )
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      return _vm.toggleSoloPost(
                                                        group.master
                                                      )
                                                    }
                                                  },
                                                  nativeOn: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  { staticClass: "title-text" },
                                                  [
                                                    _vm.isUnlinkedSeriesChild(
                                                      group.master
                                                    )
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "link-icon"
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fas fa-unlink"
                                                            })
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(
                                                      "\n                          " +
                                                        _vm._s(
                                                          group.master.title ||
                                                            "(Untitled Post)"
                                                        ) +
                                                        "\n                        "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "dtd infos users" },
                                          [
                                            group.master.coordinator_name
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "info-bubbles"
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "initials badge badge-primary",
                                                        attrs: {
                                                          title:
                                                            group.master
                                                              .coordinator_name
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.getInitials(
                                                              group.master
                                                                .coordinator_name
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "dtd infos publish-date"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "dup-series-post-count-wrap"
                                              },
                                              [
                                                _c("input", {
                                                  staticClass:
                                                    "form-control dup-series-post-count",
                                                  attrs: {
                                                    type: "number",
                                                    min: "0"
                                                  },
                                                  domProps: {
                                                    value: _vm.getSoloPostCount(
                                                      group.master
                                                    )
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                    },
                                                    change: function($event) {
                                                      return _vm.setSoloPostCount(
                                                        group.master,
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "dup-series-post-count-total"
                                                  },
                                                  [_vm._v("/ 1")]
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "dtd infos caption" },
                                          [
                                            _c("div", {
                                              staticClass: "char-count",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.getCaption(
                                                    group.master,
                                                    true
                                                  )
                                                )
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("div", {
                                              staticClass: "caption-text",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.getCaption(
                                                    group.master,
                                                    false
                                                  )
                                                )
                                              }
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass: "dtd infos thumbnail",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.getThumbnailHtml(group.master)
                                            )
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "dtd infos social-networks"
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "info-bubbles social-networks"
                                              },
                                              _vm._l(
                                                group.master.social_networks,
                                                function(net) {
                                                  return _c(
                                                    "span",
                                                    {
                                                      key:
                                                        "net-" +
                                                        group.master.id +
                                                        "-" +
                                                        net,
                                                      class:
                                                        "social-networks initials badge badge-primary " +
                                                        _vm.getSocialNetworkColorClass(
                                                          net,
                                                          group.master
                                                        ),
                                                      attrs: {
                                                        title: _vm.getSocialNetworkTypeByIdLocal(
                                                          net
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        class:
                                                          "fab fa-" +
                                                          _vm.getSocialNetworkClassByIdLocal(
                                                            net
                                                          ) +
                                                          " platform-indicator"
                                                      })
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "dtd infos languages"
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "info-bubbles languages"
                                              },
                                              _vm._l(
                                                group.master.languages,
                                                function(lang) {
                                                  return _c(
                                                    "span",
                                                    {
                                                      key:
                                                        "lang-" +
                                                        group.master.id +
                                                        "-" +
                                                        lang,
                                                      staticClass:
                                                        "languages initials badge badge-primary",
                                                      class: _vm.getLangColorClass(
                                                        lang,
                                                        group.master
                                                      ),
                                                      attrs: {
                                                        title: _vm.getLangCodeByIdLocal(
                                                          lang
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.getLangCodeByIdLocal(
                                                              lang
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _c(
                                      "div",
                                      {
                                        key:
                                          "dup-post-series-" + group.master.id,
                                        staticClass:
                                          "dtr listing-row is-social-series",
                                        class: {
                                          "dup-item-selected": _vm.isPostSelected(
                                            group.master.id
                                          )
                                        },
                                        attrs: {
                                          "data-deliverable-id": group.master.id
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "dtd titles breakpoint__fix"
                                          },
                                          [
                                            _c("div", {
                                              staticClass:
                                                "list-deliverable-status-bar",
                                              style: {
                                                borderLeftColor: _vm.getStatusColor(
                                                  group.master
                                                )
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "deliverable-title edit-d-title-stacked delete-bar-left cursor-pointer",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.toggleSeries(
                                                      group
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("b-form-checkbox", {
                                                  staticClass:
                                                    "mr-2 dup-item-checkbox dup-series-checkbox d-inline-block",
                                                  attrs: {
                                                    checked: _vm.isPostSelected(
                                                      group.master.id
                                                    )
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      return _vm.toggleSeries(
                                                        group
                                                      )
                                                    }
                                                  },
                                                  nativeOn: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  { staticClass: "title-text" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        group.master.title ||
                                                          "(Untitled Post)"
                                                      )
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "dtd infos users" },
                                          [
                                            group.master.coordinator_name
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "info-bubbles"
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "initials badge badge-primary",
                                                        attrs: {
                                                          title:
                                                            group.master
                                                              .coordinator_name
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.getInitials(
                                                              group.master
                                                                .coordinator_name
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "dtd infos publish-date"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "dup-series-post-count-wrap"
                                              },
                                              [
                                                _c("input", {
                                                  staticClass:
                                                    "form-control dup-series-post-count",
                                                  attrs: {
                                                    type: "number",
                                                    min: "0"
                                                  },
                                                  domProps: {
                                                    value: _vm.getSeriesPostCount(
                                                      group
                                                    )
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                    },
                                                    change: function($event) {
                                                      return _vm.setSeriesPostCount(
                                                        group,
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "dup-series-post-count-total"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "/ " +
                                                        _vm._s(
                                                          group.members.length
                                                        )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "dtd infos caption" },
                                          [
                                            _c("div", {
                                              staticClass: "char-count",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.getCaption(
                                                    group.master,
                                                    true
                                                  )
                                                )
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("div", {
                                              staticClass: "caption-text",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.getCaption(
                                                    group.master,
                                                    false
                                                  )
                                                )
                                              }
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass: "dtd infos thumbnail",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.getThumbnailHtml(group.master)
                                            )
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "dtd infos social-networks"
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "info-bubbles social-networks"
                                              },
                                              _vm._l(
                                                group.master.social_networks,
                                                function(net) {
                                                  return _c(
                                                    "span",
                                                    {
                                                      key:
                                                        "net-" +
                                                        group.master.id +
                                                        "-" +
                                                        net,
                                                      class:
                                                        "social-networks initials badge badge-primary " +
                                                        _vm.getSocialNetworkColorClass(
                                                          net,
                                                          group.master
                                                        ),
                                                      attrs: {
                                                        title: _vm.getSocialNetworkTypeByIdLocal(
                                                          net
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        class:
                                                          "fab fa-" +
                                                          _vm.getSocialNetworkClassByIdLocal(
                                                            net
                                                          ) +
                                                          " platform-indicator"
                                                      })
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "dtd infos languages"
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "info-bubbles languages"
                                              },
                                              _vm._l(
                                                group.master.languages,
                                                function(lang) {
                                                  return _c(
                                                    "span",
                                                    {
                                                      key:
                                                        "lang-" +
                                                        group.master.id +
                                                        "-" +
                                                        lang,
                                                      staticClass:
                                                        "languages initials badge badge-primary",
                                                      class: _vm.getLangColorClass(
                                                        lang,
                                                        group.master
                                                      ),
                                                      attrs: {
                                                        title: _vm.getLangCodeByIdLocal(
                                                          lang
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.getLangCodeByIdLocal(
                                                              lang
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          ]
                                        )
                                      ]
                                    )
                              ]
                            })
                          ],
                          2
                        )
                      ]
                    )
                  ])
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "dup-modal-footer d-flex justify-content-end mt-3" },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  on: {
                    click: function($event) {
                      return _vm.$emit("close")
                    }
                  }
                },
                [
                  _vm._v(
                    "\n        Done (" +
                      _vm._s(_vm.selectedCount) +
                      " posts selected)\n      "
                  )
                ]
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }